import React from "react";
import { useNavigate } from "react-router";
import { useTranslation } from 'react-i18next';

const WelcomePage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleStartMission = () => {
        navigate('/home');
    };

    return (
        <section style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            width: '100%',
            padding: '20px',
            boxSizing: 'border-box'
        }}>
            <div style={{
                width: '90%',
                maxWidth: '800px',
                textAlign: 'center',
                fontFamily: 'Merriweather',
                color: 'white',
                padding: '40px 20px',
                backgroundColor: '#7C112B',
                boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.3)'
            }}>
                <h1 style={{
                    fontSize: '28px',
                    fontWeight: 'bold',
                    color: '#FDB933',
                    marginBottom: '30px',
                    textAlign: 'center'
                }}>
                    {t('WelcomeTitle')}
                </h1>
                <div style={{
                    fontSize: '16px',
                    lineHeight: '1.8',
                    marginBottom: '40px',
                    whiteSpace: 'pre-wrap',
                    textAlign: 'left'
                }}>
                    {t('WelcomeText')}
                </div>
                <button
                    onClick={handleStartMission}
                    style={{
                        padding: "15px 40px",
                        borderRadius: "0px",
                        border: "2px solid #FDB933",
                        backgroundColor: "#FDB933",
                        color: "#7C112B",
                        fontFamily: "Merriweather",
                        fontSize: '16px',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                    }}
                >
                    {t('WelcomeButton')}
                </button>
            </div>
        </section>
    );
};

export default WelcomePage;

